import { render, staticRenderFns } from "./SmartCatalogSearch.vue?vue&type=template&id=42a2ca99&scoped=true&"
import script from "./SmartCatalogSearch.vue?vue&type=script&lang=js&"
export * from "./SmartCatalogSearch.vue?vue&type=script&lang=js&"
import style0 from "./SmartCatalogSearch.vue?vue&type=style&index=0&id=42a2ca99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a2ca99",
  null
  
)

export default component.exports